<template>
  <!-- 组件主盒子 -->
  <div>
    <div class="query-select">
      <el-form ref="queryForm" :model="queryForm" :inline="true">
        <el-form-item label="题干：">
          <el-input
            size="small"
            v-model="queryForm.questionStem"
            placeholder="请输入题干"
          ></el-input>
        </el-form-item>
        <el-form-item label="题型：">
          <el-select
            size="small"
            v-model="queryForm.questionType"
            placeholder="请选择题型"
            @change="getTableInfo"
            clearable
          >
            <el-option label="单选" value="1"></el-option>
            <el-option label="多选" value="3"></el-option>
            <el-option label="判断" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="等级：">
          <el-select
            size="small"
            v-model="queryForm.courseLevel"
            placeholder="请选择难度等级"
            @change="getTableInfo"
            clearable
          >
            <el-option
              v-for="item in examLevel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：" class="mr-left">
          <el-date-picker
            size="small"
            v-model="dateRange"
            @change="getTableInfo"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableInfo"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="reset"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          size="small"
          round
          @click="openForm('create')"
          >新增</el-button
        >
        <el-button
          type="success"
          icon="el-icon-upload2"
          plain
          size="small"
          round
          @click="onUpload"
          >导入</el-button
        >
      </div>
    </div>
    <!-- 分割 -->
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        border
        stripe
        size="small"
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionStem"
          label="题干"
          width="500"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="courseLevel"
          label="等级"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ getExamLabel(scope.row.courseLevel) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="questionType" label="题型">
        </el-table-column>
        <el-table-column align="center" prop="questionAnswer" label="答案">
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              plain
              type="primary"
              @click="openDetail(scope.row.questionsId)"
              >查看</el-button
            >
            <el-button
              size="mini"
              round
              plain
              type="warning"
              @click="openForm('edit', scope.row.questionsId)"
              >编辑</el-button
            >

            <el-button
              type="danger"
              plain
              size="mini"
              round
              @click="removeClick(scope.row.questionsId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="total, prev, pager, next"
        :current-page.async="queryForm.pageNum"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <TheoryBankDetail ref="detailRef"></TheoryBankDetail>
    <TheoryBankForm ref="formRef" @success="getTableInfo"></TheoryBankForm>
    <TheoryBankUpload
      ref="uploadRef"
      @success="getTableInfo"
    ></TheoryBankUpload>
  </div>
</template>
<script>
import { getQuestionBankTable, removeQuestion } from "@/api/manage";
import { examLevel, getExamLabel } from "@/utils/dict.js";
import { tansParams } from "@/utils/util";
import TheoryBankUpload from "./TheoryBankUpload.vue";
import TheoryBankForm from "./TheoryBankForm.vue";
import TheoryBankDetail from "./TheoryBankDetail.vue";
export default {
  name: "TheoryBank",
  components: {
    TheoryBankUpload,
    TheoryBankForm,
    TheoryBankDetail
  },
  data() {
    const checkAddMore = (rule, value, callback) => {
      let res = 0;
      this.modelForm.moreSelectArr.forEach(item => {
        if (item.answerStem == value) {
          res += 1;
        }
      });
      if (res > 1) {
        callback(new Error("该选项已存在"));
      }
      callback();
    };
    const checkAddRadio = (rule, value, callback) => {
      let res = 0;
      this.modelForm.radioSelectArr.forEach(item => {
        if (item.answerStem == value) {
          res += 1;
        }
      });

      if (res > 1) {
        callback(new Error("该选项已存在"));
      }
      callback();
    };
    const checkEditMore = (rule, value, callback) => {
      let res = 0;
      this.editModelForm.editMoreSelectArr.forEach(item => {
        if (item.answerStem == value) {
          res += 1;
        }
      });
      if (res > 1) {
        callback(new Error("该选项已存在"));
      }
      callback();
    };
    const checkEditRadio = (rule, value, callback) => {
      let res = 0;
      this.editModelForm.editRadioSelectArr.forEach(item => {
        if (item.answerStem == value) {
          res += 1;
        }
      });
      if (res > 1) {
        callback(new Error("该选项已存在"));
      }
      callback();
    };
    return {
      examLevel,
      loading: false,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        questionType: "",
        courseLevel: "",
        questionStem: ""
      },
      dateRange: null,
      totalCount: 0,
      tableData: null
    };
  },

  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.loading = true;
    this.getTableInfo();
  },
  // 里面的函数只有调用才会执行
  methods: {
    getExamLabel,
    openForm(type, id) {
      this.$refs.formRef.open(type, id);
    },
    onUpload() {
      this.$refs.uploadRef.open();
    },
    selectQuestionType() {
      this.getTableInfo();
    },
    async openDetail(id) {
      this.$refs.detailRef.open(id);
    },
    async removeClick(id) {
      this.$confirm("此操作将删除该内容,并进入回收站,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await removeQuestion(id);
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getTableInfo();
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          }
        })
        .catch(() => {});
    },

    async getTableInfo() {
      let obj;
      let requireAddress;
      if (this.dateRange != null) {
        obj = {
          ...this.queryForm,
          params: { beginTime: this.dateRange[0], endTime: this.dateRange[1] }
        };
        let url = "/trainAdmin/enterAdmin/list" + "?" + tansParams(obj);
        url = url.slice(0, -1);
        obj = {};
        requireAddress = url;
        let config = {};
        if (window.localStorage.getItem("token") != null) {
          config = {
            headers: {
              Authorization: window.localStorage.getItem("token")
            }
          };
        } else {
          this.$router.push({ path: "/login" });
          this.$message({
            type: "success",
            message: "请登录!"
          });
        }
        // str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '')
        await this.$https.get(requireAddress, config).then(res => {
          let result = res.data;
          this.loading = false;
          if (result.code == 200) {
            this.tableData = res.data.data.rows.map(i => ({
              ...i,
              questionType:
                i.questionType == 1
                  ? "单选题"
                  : i.questionType == 3
                  ? "多选题"
                  : i.questionType == 2
                  ? "判断题"
                  : "",
              questionStem: i.questionStem
            }));
            this.totalCount = res.data.data.total;
          }
        });
      } else {
        const res = await getQuestionBankTable(this.queryForm);

        this.loading = false;
        if (res.data.code === 200) {
          this.tableData = res.data.data.rows.map(i => ({
            ...i,
            questionType:
              i.questionType == 1
                ? "单选题"
                : i.questionType == 3
                ? "多选题"
                : i.questionType == 2
                ? "判断题"
                : "",
            questionStem: i.questionStem
          }));
          this.totalCount = res.data.data.total;
        }
      }
    },

    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getTableInfo();
    },

    reset() {
      this.queryForm.pageNum = 1;
      this.dateRange = null;
      this.queryForm.questionType = "";
      this.queryForm.courseLevel = "";
      this.queryForm.questionStem = "";
      this.getTableInfo();
    }
  },
  computed: {
    styles() {
      let style = {};
      if (this.minHeight) {
        style.minHeight = `${this.minHeight}px`;
      }
      if (this.height) {
        style.height = `${this.height}px`;
      }
      return style;
    }
  },
  watch: {}
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
&::-webkit-scrollbar {
  width: 3px;
  height: 5px;
}

// 滚动条里面默认的小方块,自定义样式
&::-webkit-scrollbar-thumb {
  background: #8798af;
  border-radius: 2px;
}

// 滚动条里面的轨道
&::-webkit-scrollbar-track {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/Bank/TheoryBank/index.vue